
define('ldsh!modules/form_editor/templates/editor_advanced_dropdown', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="ed-form-group ed-advanced-item ' +
((__t = ( hasUrlLoad? '' : 'hidden' )) == null ? '' : __t) +
'">\n  <label>\n    <span data-i18n="formEditor.dropdownURL"></span>\n  </label>\n  <input type="text" class="form-control ed-form-item-full js-dropdown-url" value="' +
((__t = ( url )) == null ? '' : __t) +
'" placeholder="https://">\n  <em class="field-helper mb12 block mt12 weight-400">\n    <i class="ri-question-line f16"></i>\n    ';
 if (isAMP) { ;
__p += '\n      <span data-i18n="formEditor.dropdownURLHelpAMP"></span>\n      <a class="blue"\n        target="_blank"\n        href="https://ampproject-b5f4c.firebaseapp.com/examples/data/amp-list-urls.json"\n        data-i18n="[title]formEditor.dropdownURLHelpAMPHelpTitle"><span\n        data-i18n="formEditor.dropdownURLHelpAMPHelp"></span></a>\n    ';
 } else { ;
__p += '\n      <span data-i18n="[html]formEditor.dropdownURLHelp"></span>\n    ';
 } ;
__p += '\n  </em>\n</div>\n\n';
 if (!isAMP) { ;
__p += '\n  <div class="ed-form-group ed-form-group-file btn--secondary js-browse mb24 e100 ' +
((__t = ( hasCsvLoad? '' : 'hidden' )) == null ? '' : __t) +
'">\n    <label for="">\n      <span data-i18n="formEditor.dropDownCsvButton"></span> <i class="ed-icon ed-icon-download" aria-hidden="true"></i>\n    </label>\n    <input type="file" value="value" class="ed-form-control js-file ed-form-item-full ed-form-file">\n  </div>\n  <span data-i18n="formEditor.dropDownCsvError" class="ed-error-txt js-error-csv hidden"></span>\n';
 } ;
__p += '\n';

}
return __p
};});

